import { FC, useMemo } from "react";
import { Box, Grid } from "@mui/material";
import ExternalLink from "../ExternalLink";
import Chart from "../Chart";
import { MultiCalc } from "../../types/analyzer";
import { formatPercentage } from "../../utils/numeric";
import { useStyles } from "./styles";

import ImgBg from "../../assets/images/products/crypto-offering/coin_bg.svg";

interface Props {
  title: string;
  description: string;
  chartData: number[][];
  multiCalcData: MultiCalc[];
}

const CryptoOfferingCoin: FC<Props> = ({
  title,
  description,
  chartData,
  multiCalcData,
}) => {
  const classes = useStyles();

  const chartValues = useMemo(
    () => chartData.map((item) => item[1]),
    [chartData]
  );

  if (!multiCalcData.length) return null;

  const specificRealtimeValue = formatPercentage(multiCalcData?.[0]["YTD"]); // TODO: verify this is the correct value to use
  const specificReturnValue = formatPercentage(multiCalcData?.[0]["1Y"]);
  const specificVolatilityValue = formatPercentage(multiCalcData?.[3]["1Y"]);

  return (
    <Box py={4}>
      <Grid container spacing={8}>
        <Grid item xs={12} md={6}>
          <Box className={classes.main}>
            <Box className={classes.mainTitle}>{title}</Box>
            <Box className={classes.mainTitleBorder} />
            <Box className={classes.mainDescription}>{description}</Box>
            <Box>
              <ExternalLink label="Methodology Guide" link="#" />
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={6} display={{ xs: "none", md: "block" }}>
          <Box className={classes.chart}>
            <img src={ImgBg} alt="" />
            <Box className={classes.chartMain}>
              <Box className={classes.chartTitle}>BITA {title} Price Index</Box>
              <Box className={classes.chartContainer}>
                <Chart
                  dataSeries={[
                    {
                      type: "line",
                      name: `BITA ${title} Price Index`,
                      data: chartData,
                      color: "#fff",
                      lineColor: "#fff",
                    },
                  ]}
                  chartOptions={{
                    chart: { backgroundColor: "transparent", height: 160 },
                    xAxis: { visible: false },
                    yAxis: {
                      visible: false,
                      min: Math.min(...chartValues),
                      max: Math.max(...chartValues),
                    },
                  }}
                  size="sm"
                />
              </Box>
              <Box className={classes.chartBottomSection}>
                <Box className={classes.realTimeContainer}>
                  <Box className={classes.realTimeLabel}>Real Time</Box>
                  <Box className={classes.realtimeValue}>
                    {specificRealtimeValue}
                  </Box>
                </Box>
                <Box className={classes.smallBoxes}>
                  <Box className={classes.smallBox}>
                    <Box className={classes.smallBoxLabel}>1-Yr Return</Box>
                    <Box>{specificReturnValue}</Box>
                  </Box>
                  <Box className={classes.smallBox}>
                    <Box className={classes.smallBoxLabel}>1-Yr Volatility</Box>
                    <Box>{specificVolatilityValue}</Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CryptoOfferingCoin;
